<template>
  <div>
    <TopHeader2 underlineItem="لیست همکاران"></TopHeader2>

    <main v-if="doctors" class="main">
      <PagesPath :items="['لیست همکاران']" :last="'partners'"></PagesPath>
      <section id="mainContent">
        <div v-if="homeData" id="headerContent">
          <img :src="'https://api.infinity-align.com/storage/'+homeData.settings.partners_page_image" alt="" />
          <p>
            {{homeData.settings.partners_page_text1 }}
          </p>
        </div>
        <div v-if="doctors.length" id="tableContent">
          <h3>ليست همکاران ما در سراسر کشور</h3>
          <input
            type="text"
            placeholder="جستجو بر اساس استان - شهر و یا نام همکار"
            v-model="search"
          />
          <table>
            <thead>
              <tr>
                <th>ردیف</th>
                <th>نام و نام خانوادگی</th>
                <th>استان</th>
                <th>شهر</th>
                <th>آدرس</th>
                <th>تلفن مطب</th>
              </tr>
            </thead>
            <tbody>
              <tr
                @click="redirectCall(item.officePhone?item.officePhone[0]:'')"
                v-for="(item, index) in mainList"
                :key="item"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.city.province.name }}</td>
                <td>{{ item.city.name }}</td>
                <td>{{ item.officeAddress }}</td>
                <td>{{ item.officePhone?item.officePhone.toString():"" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </main>
    <loader v-else />
  </div>
</template>

<script>
import TopHeader2 from "../components/TopHeader2";
import PagesPath from "../components/PagesPath";
import loader from "@/components/loader.vue";

export default {
  name: "Videos",
  components: {
    TopHeader2,
    loader,
    PagesPath,
  },
  methods: {
    redirectCall(phone) {
      if (window.innerWidth < 768 && phone) {
        window.location.href = `tel://${phone}`;
      }
    },
  },
  metaInfo() {
    return {};
  },
  data() {
    return {
      search: null,
      doctors: [],
    };
  },
  computed: {
    homeData(){
        return this.$root.homeData
    },
    mainList() {
      if (this.search == null || this.search == "") {
        return this.doctors;
      }
      return this.doctors.filter((item) => {
        if (
          item.name.match(this.search) ||
          item.city.province.name.match(this.search) ||
          item.city.name.match(this.search)
        ) {
          return item;
        }
      });
    },
  },
  mounted(){
    this.$axios.get("https://api.infinity-align.com/api/doctors").then((res)=>{
        this.doctors=res.data.doctors
    })
  }
};
</script>

<style scoped>
#tableContent h3 {
  direction: rtl;
  text-align: right;
  margin: 24px;
}
section#mainContent {
  width: 100%;
  margin: 24px auto;
}
div#headerContent p {
  direction: rtl;
  text-align: justify;
}
div#headerContent img {
  width: 50%;
}
div#headerContent {
  display: flex;
  width: 80%;
  margin: auto;
  gap: 16px;
  align-items: center;
}

div#tableContent table tbody tr:nth-child(odd) {
  background: #80808069;
}

div#tableContent table tbody td {
    text-align: center;
    padding: 4px 0;
  font-size: 18px;
}
div#tableContent table thead th {
  padding: 5px;
}
div#tableContent table thead {
  background: black;
  color: white;
  text-align: center;
}
div#tableContent table {
  width: 90%;
  margin: auto;
  border: 1px solid black;
}

div#tableContent input {
  width: 90%;
  margin: 16px auto;
  padding: 8px 16px;
  border-bottom: 1px solid #00000061;
}
div#tableContent {
  width: 80%;
  margin: auto;
  display: flex;
  flex-direction: column;
}
@media (max-width: 991px) {
  .main {
    margin-top: 24px;
  }
  div#headerContent {
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
  div#headerContent img {
    width: 90%;
  }
  #tableContent {
    width: 95% !important;
  }
  #tableContent h3 {
    font-size: 20px;
  }
  div#tableContent table tbody td {
    font-size: 14px;
  }
}
</style>
